







import { defineComponent, onMounted } from "@vue/composition-api";
import useConfig from "./composition/useConfig";

export default defineComponent( {
  props: {
    api: String
  },
  setup(props) {
    
    // onMounted(() => console.log("api url:", process.env.VUE_APP_API_URL))
    onMounted(() => {
      const { setBaseUrl } = useConfig()
      console.log("mensaje:", props.api)
      setBaseUrl(props.api)
      })
    return {};
  },
  computed: {
    background(): any {
      const { theme } =  this.$vuetify
      const nombre = theme.dark ? "dark" : "light";
      return theme.themes[nombre].background;
    },
  }
})
